import TimeBlockList from './TimeBlockList';
import Button from '../shared/Button';
import { useItineraryGenerator } from '../../hooks/useItineraryGenerator';
import useTripStore from '../../context/TripStore';

const TimeBlocks = () => {
  const setCurrentStep = useTripStore((state) => state.setCurrentStep);
  const { generate, isGenerating, error } = useItineraryGenerator();

  const handleBack = () => {
    setCurrentStep('list');
  };

  const handleGenerate = async () => {
    console.log('Generate button clicked');
    try {
      console.log('Calling generate()...');
      const result = await generate();
      console.log('Generate completed, result:', result);
      setCurrentStep('itinerary');
    } catch (err) {
      // Error is handled by the hook
      console.error('Failed to generate itinerary:', err);
      alert(`Failed to generate itinerary: ${err.message}`);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-light mb-6 tracking-tight">Set Time Blocks</h1>

      <div className="space-y-4 mb-6">
        <p className="text-xs font-light text-gray-500">
          Lock specific times for reservations, timed entries, or fixed commitments. 
          The itinerary will be built around these time-locked items.
        </p>
        <TimeBlockList />
      </div>

      {error && (
        <div className="border border-gray-300 text-xs font-light text-gray-700 px-3 py-2 mb-4">
          {error}
        </div>
      )}

      <div className="flex justify-between">
        <Button variant="secondary" onClick={handleBack} disabled={isGenerating}>
          Back
        </Button>
        <Button onClick={handleGenerate} disabled={isGenerating}>
          {isGenerating ? 'Generating Itinerary...' : 'Generate Itinerary'}
        </Button>
      </div>
    </div>
  );
};

export default TimeBlocks;

